export var Permission;
(function (Permission) {
    Permission["CREATE_FOLDER"] = "CREATE_FOLDER";
    Permission["UPLOAD_FILE"] = "UPLOAD_FILE";
    Permission["MODERATE"] = "MODERATE";
    Permission["ACCESS"] = "ACCESS";
})(Permission || (Permission = {}));
export var RoleType;
(function (RoleType) {
    RoleType["ALL_MEMBERS"] = "ALL_MEMBERS";
    RoleType["ADMINS"] = "ADMINS";
    RoleType["CUSTOM"] = "CUSTOM";
    RoleType["PLAN"] = "PLAN";
    RoleType["MEMBER"] = "MEMBER";
    RoleType["SITE_VISITORS"] = "SITE_VISITORS";
    RoleType["BADGE"] = "BADGE";
})(RoleType || (RoleType = {}));
export var PermissionsLevelEnumPermissionsLevel;
(function (PermissionsLevelEnumPermissionsLevel) {
    PermissionsLevelEnumPermissionsLevel["UNKNOWN"] = "UNKNOWN";
    PermissionsLevelEnumPermissionsLevel["NONE"] = "NONE";
    PermissionsLevelEnumPermissionsLevel["VIEW"] = "VIEW";
    PermissionsLevelEnumPermissionsLevel["CONTRIBUTE"] = "CONTRIBUTE";
    PermissionsLevelEnumPermissionsLevel["MANAGE"] = "MANAGE";
})(PermissionsLevelEnumPermissionsLevel || (PermissionsLevelEnumPermissionsLevel = {}));
export var AccessPermissionFlag;
(function (AccessPermissionFlag) {
    /**
     * indicates if provided library item is visible by anonymous users
     * when false only members having ACCESS permission can see library item
     */
    AccessPermissionFlag["PUBLIC"] = "PUBLIC";
    /** Folder is still public but access to its contents is restricted */
    AccessPermissionFlag["PUBLIC_CONTENTS_HIDDEN"] = "PUBLIC_CONTENTS_HIDDEN";
    /** Folder and its contents will be visible only to members having access permission */
    AccessPermissionFlag["HIDDEN"] = "HIDDEN";
})(AccessPermissionFlag || (AccessPermissionFlag = {}));
export var Availability;
(function (Availability) {
    Availability["UNKNOWN"] = "UNKNOWN";
    Availability["PUBLIC"] = "PUBLIC";
    Availability["PUBLIC_HIDDEN"] = "PUBLIC_HIDDEN";
    Availability["MEMBER"] = "MEMBER";
    Availability["PAID"] = "PAID";
    Availability["MEMBER_HIDDEN"] = "MEMBER_HIDDEN";
    Availability["PAID_HIDDEN"] = "PAID_HIDDEN";
})(Availability || (Availability = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map